import { useState, useRef, useMemo, useEffect  } from 'react';
import { OptionType, OptionMore, MessageType } from 'models/BaseModel'
import { Utility } from 'helpers/UtilityHelpers';
import { Privilege } from 'models/BaseModel';
import { useNavigate } from 'react-router-dom';
import { Code } from 'constants/codes';
import { Security } from 'helpers/SecurityHelper';

const useOptions = () => {
  return useState<OptionType[]>([]);
};

const useOptionMore = () => {
  return useState<OptionMore[]>([]);
};

export type Position = {
  x: number;
  y: number;
};

const usePosition = () => {
  return useState<Position>({ x: 0, y: 0 });
};

const useDiv = () => {
  return useRef<HTMLDivElement | null>(null);
};

const useFrame = () => {
  return useRef<HTMLIFrameElement>(null);
};

const useListPrivileges = (formId: number) => {
  return useMemo(() => {
    const Privilege = Security.Privilege.List(formId);
    return Privilege
  }, [formId]);
};

const useSpecialPrivileges = () => {
  return useMemo(() => {
    const Privilege = Security.Privilege.Special();
    return Privilege
  }, []);
};

const useReportPrivileges = () => {
  return useMemo(() => {
    const Privilege = Security.Privilege.Report();
    return Privilege
  }, []);
};

const useHasViewPrivilege = (Privilege: Privilege) => {
  const navigate = useNavigate();
  useEffect(() => {
    if(!Privilege.ALL && !Privilege.VIEW){
      navigate(Code.Path.NO_PRIVILEGE);
    }
    
  }, [navigate]);
};

const useHasOpenPrivilege = (Privilege: Privilege) => {
  const navigate = useNavigate();
  useEffect(() => {
    if(!Privilege.ALL && !Privilege.OPEN){
      navigate(Code.Path.NO_PRIVILEGE);
    }
    
  }, [navigate]);
};

const useHasPrintPrivilege = (Privilege: Privilege) => {
  const navigate = useNavigate();
  useEffect(() => {
    if(!Privilege.ALL && !Privilege.PRINT){
      navigate(Code.Path.NO_PRIVILEGE);
    }
    
  }, [navigate]);
};

export const Hooks = {
  Form:{
    Position: usePosition,
    Div: useDiv,
    Frame: useFrame,
    Options: useOptions,
    OptionMore: useOptionMore
  },
  Privilege:{
    List: useListPrivileges,
    Special: useSpecialPrivileges,
    Report: useReportPrivileges,
    HasView: useHasViewPrivilege,
    HasOpen: useHasOpenPrivilege,
    HasPrint: useHasPrintPrivilege,
  }
}

